import { useState, useEffect, useReducer, useCallback } from 'react';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var LazyloadActions = /* @__PURE__ */ ((LazyloadActions2) => {
  LazyloadActions2["LOAD_MORE"] = "LOAD_MORE";
  return LazyloadActions2;
})(LazyloadActions || {});
const lazyloadReducer = (state, action) => {
  switch (action.type) {
    case "LOAD_MORE" /* LOAD_MORE */:
      return __spreadProps(__spreadValues({}, state), { loaded: state.loaded + 1 });
    default:
      return state;
  }
};
const useLazyload = (observerRef, config) => {
  const [initialized, setInitialized] = useState(false);
  const [observer, setObserver] = useState();
  const [maxObservation, setMaxObservation] = useState(0);
  useEffect(() => {
    if (config == null ? void 0 : config.maxObservation) {
      setMaxObservation(config.maxObservation);
    }
  }, [config, setMaxObservation]);
  const firstload = (config == null ? void 0 : config.firstload) ? config.firstload : 0;
  const [lazyloadState, lazyloadDispatch] = useReducer(lazyloadReducer, {
    loaded: firstload
  });
  const scrollObserver = useCallback((node) => {
    if (node === null) {
      return;
    }
    let observationCount = maxObservation;
    return new IntersectionObserver((entries, self) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          if (observationCount === 0) {
            self.unobserve(entry.target);
          } else {
            lazyloadDispatch({ type: "LOAD_MORE" /* LOAD_MORE */ });
            observationCount--;
          }
        }
      });
      return self;
    });
  }, [lazyloadDispatch, maxObservation]);
  useEffect(() => {
    if (initialized && !observer && (observerRef == null ? void 0 : observerRef.current)) {
      setObserver(scrollObserver(observerRef.current));
    }
  }, [initialized, observerRef, observer, scrollObserver]);
  useEffect(() => {
    if (observer && (observerRef == null ? void 0 : observerRef.current)) {
      observer == null ? void 0 : observer.observe(observerRef.current);
    }
    return () => {
      observer == null ? void 0 : observer.disconnect();
    };
  }, [observerRef, observer]);
  const lazyloadInit = () => {
    if (!("IntersectionObserver" in window)) {
      return false;
    }
    setInitialized(true);
    return true;
  };
  return {
    init: () => {
      return lazyloadInit();
    },
    more: () => {
      lazyloadDispatch({ type: "LOAD_MORE" /* LOAD_MORE */ });
    },
    loaded: () => {
      return lazyloadState.loaded;
    }
  };
};

export { LazyloadActions, useLazyload };
//# sourceMappingURL=useLazyload.es.js.map
